import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';
import uniqueId from 'lodash/uniqueId';

const toastAdapter = getAdapter();

const toastSlice = createSlice({
  name: 'toast',
  initialState: toastAdapter.getInitialState(),
  reducers: {
    addToast: (state, { payload }) => {
      const newToast = { id: uniqueId(), ...payload };
      toastAdapter.addOne(state, newToast);
    },
    removeToast: (state, { payload: { id } }) => {
      toastAdapter.removeOne(state, id);
    },
  },
});

const selectors = toastAdapter.getSelectors(({ toast }) => toast);

export const getItems = (state) => selectors.selectAll(state);

export const { addToast, removeToast } = toastSlice.actions;

export default toastSlice.reducer;
